import React, { useState } from "react";
import { Form, Row, Modal } from "react-bootstrap";
import "./popUpStyle.css";
import ApiService from "../../../ApiService";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const AppointmentReq = props => {
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackText, setSnackText] = useState("");
  const [snackSeverity, setSnackSeverity] = useState("");
  const handleSnackClose = () => {
    setSnackOpen(false);
  };
  const handleSnackOpen = (text, severity) => {
    setSnackSeverity(severity);
    setSnackText(text);
    setSnackOpen(true);
  };

  const [internalNote, setInternalNotes] = useState({
    template: `Hi ${props?.patient?.firstName}  ${props?.patient?.lastName},        
            Thank you for your patience! Your results have come in and I would like to go over them with you.
            Please book a time on my calendar that works bests for your schedule.
            Here is a link to my calendar to make finding time easier:
            {meetingLink}
            Warmly,
            ${props?.clinician?.firstName} ${props?.clinician?.lastName}`
  });

  const sendAppointmentRequest = async () => {
    try {
      const r = await ApiService.postAppointment({ testResultId: props.kit, message: internalNote.template });
      handleSnackOpen("Appointment Request Sent", "success");
    } catch (error) {
      console.error(error);
      handleSnackOpen(error.message, "error");
    }
  };

  return (
    <Modal size="lg" show={props.showAppReqModal} onHide={() => props.closeAppReqModal} backdrop={"static"}>
      <Modal.Header id="ModalTitle">
        <Modal.Title>Appointment Request</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group controlId="patientDetailsFormId">
          <Form.Control
            id="popup-textarea"
            as="textarea"
            rows={10}
            value={internalNote.template}
            onChange={e => setInternalNotes({ ...internalNote, template: e.target.value })}
          />
        </Form.Group>
        <Row className="modal-footer">
          <button class="btn btn-light" onClick={props.closeAppReqModal}>
            Cancel
          </button>
          <button id="msg_reply" class="btn btn-primary" onClick={sendAppointmentRequest}>
            Send Request <i class="fa fa-paper-plane" aria-hidden="true"></i>
          </button>
        </Row>
      </Modal.Body>
      <Snackbar open={snackOpen} autoHideDuration={6000} onClose={handleSnackClose} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert onClose={handleSnackClose} severity={snackSeverity}>
          {snackText}
        </Alert>
      </Snackbar>
    </Modal>
  );
};

export default AppointmentReq;
